module.exports = __webpack_public_path__ + "static/media/stock-out.9b0dea19.svg";